import { Link } from 'react-router-dom'

import { Wordmark } from '@/features/landing/components/Wordmark'
import { requestConsentPrompt } from '@/lib/analytics/consent'

const COLUMNS = [
  {
    heading: 'Product',
    links: [
      { label: 'Why e404', to: '#why' },
      { label: 'Pricing', to: '#pricing' },
      { label: 'Mobile', to: '#mobile' },
      { label: 'Changelog', to: '/changelog' },
    ],
  },
  {
    heading: 'Legal',
    links: [
      {
        label: 'Privacy',
        to: 'https://paxionfoundry.com/privacy',
        external: true,
      },
      {
        label: 'Terms',
        to: 'https://paxionfoundry.com/terms',
        external: true,
      },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'Paxion Foundry', to: 'https://paxionfoundry.com', external: true },
      { label: 'Contact', to: '/contact' },
      { label: 'Status', to: '/status' },
    ],
  },
] as const

export function Footer() {
  return (
    <footer className="px-6 py-16">
      <div className="mx-auto max-w-6xl">
        <div className="grid gap-12 md:grid-cols-[2fr_3fr]">
          {/* Brand block */}
          <div className="flex flex-col gap-4">
            <Wordmark size="lg" />
            <p className="max-w-sm text-sm text-fg-muted text-pretty">
              Where your squad actually shows up. Roster, events,
              tournaments, Discord and Twitch, all in one place.
            </p>
            <p className="font-display text-[10px] tracking-[0.25em] text-fg-subtle uppercase">
              Made for squads · Paxion Foundry
            </p>
          </div>

          {/* Link columns */}
          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
            {COLUMNS.map((col) => (
              <div key={col.heading} className="flex flex-col gap-3">
                <p className="font-display text-[10px] tracking-[0.25em] text-fg-subtle uppercase">
                  {col.heading}
                </p>
                <ul className="flex flex-col gap-2 text-sm">
                  {col.links.map((link) =>
                    'external' in link && link.external ? (
                      <li key={link.label}>
                        <a
                          href={link.to}
                          target="_blank"
                          rel="noreferrer"
                          className="text-fg-muted transition-colors hover:text-fg"
                        >
                          {link.label}
                        </a>
                      </li>
                    ) : (
                      <li key={link.label}>
                        <Link
                          to={link.to}
                          className="text-fg-muted transition-colors hover:text-fg"
                        >
                          {link.label}
                        </Link>
                      </li>
                    ),
                  )}
                  {/* Withdrawal must be as easy as consenting, so the way
                      back lives beside Privacy and Terms rather than buried.
                      A button, not a link — it opens a dialog, it does not
                      navigate. */}
                  {col.heading === 'Legal' && (
                    <li>
                      <button
                        type="button"
                        onClick={requestConsentPrompt}
                        className="text-left text-fg-muted transition-colors hover:text-fg"
                      >
                        Cookie settings
                      </button>
                    </li>
                  )}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom rule */}
        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-border/60 pt-6 md:flex-row md:items-center">
          <p className="font-display text-xs tracking-tight text-fg-subtle">
            © {new Date().getFullYear()} Paxion Foundry Ltd. All rights reserved.
          </p>
          <p className="flex items-center gap-2 font-display text-[10px] tracking-[0.25em] text-fg-subtle uppercase">
            <span className="inline-flex h-1.5 w-1.5 rounded-full bg-success" />
            Squad's online
          </p>
        </div>
      </div>
    </footer>
  )
}
